import { createContext } from 'react'
import { IDnDStageMappingContext } from '../interfaces'

/**
 * Create the context with undefined as default
 * This ensures the hook will throw an error if used outside the provider
 */
export const DnDStageMappingContext = createContext<
   IDnDStageMappingContext | undefined
>(undefined)
